import { HttpHeaders } from '@angular/common/http';
import { Injectable, Injector, inject } from '@angular/core';

import { PaymentsCashierConfig } from '../client-config/client-config.models';
import { CustomHttpClientService } from '../http/custom-http-client.service';

@Injectable({
    providedIn: 'root',
})
export class PaymentsAuthenticationService {
    protected customHttpClientService = inject(CustomHttpClientService);
    protected injector = inject(Injector);

    authenticateUser(sessionInfo: { [key: string]: string }, url: string) {
        const host = this.injector.get(PaymentsCashierConfig).host;
        const requestData: { [key: string]: string | { [key: string]: string } } = {
            userId: sessionInfo['userId'] ?? '',
            labelInfo: {
                brandId: sessionInfo['brandId'] ?? '',
                productId: sessionInfo['productId'] ?? '',
                channelId: sessionInfo['channelId'] ?? '',
            },
        };
        if (sessionInfo['LANG_ID']) {
            requestData['languageCode'] = sessionInfo['LANG_ID'];
        }

        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                // TODO: Remove once the cashier backend starts reading SSO from cookies
                'sso-key': sessionInfo['sessionKey'] || '',
            }),
            observe: 'response' as 'body',
            withCredentials: true,
        };

        return this.customHttpClientService.httpClient.post(host + url, requestData, httpOptions);
    }
}
